// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_mv-0";